import React from 'react';
import { FooterSectionContent } from './FooterSectionContent';
import { useFooterSectionController } from './FooterSection.controllers';
import { SectionContainer, StyledCloudImage, LeftAsset, RightAsset, RightBottomAsset } from './FooterSection.styles';

export const FooterSectionDesktop = () => {
  const { containerRef, assetRef, asset1Ref, asset3Ref, setIsVisible } = useFooterSectionController();
  return (
    <SectionContainer
      ref={containerRef}
      id="our_story_footer_section"
      src="our-story/footer-cta/img.jpg"
      optimization="mild"
      isResizeDisabled
      afterLoad={() => setIsVisible(true)}
    >
      <FooterSectionContent />
      <LeftAsset ref={assetRef}>
        <StyledCloudImage src="our-story/footer-cta/curl2.svg" width="55vw" height="100%" />
      </LeftAsset>
      <RightAsset ref={asset1Ref}>
        <StyledCloudImage src="our-story/footer-cta/curl1.svg" width="20vw" height="100%" />
      </RightAsset>
      <RightBottomAsset ref={asset3Ref}>
        <StyledCloudImage src="our-story/footer-cta/curl3.svg" width="25vw" height="100%" />
      </RightBottomAsset>
    </SectionContainer>
  );
};
